(function () {
  function showDemoToast(message) {
    var existing = document.querySelector('[data-xp-demo-toast]');
    if (existing) existing.remove();

    var toast = document.createElement('div');
    toast.className = 'tsl-xp-demo-toast';
    toast.setAttribute('data-xp-demo-toast', '');
    toast.setAttribute('role', 'status');
    toast.textContent = message;
    document.body.appendChild(toast);

    window.setTimeout(function () {
      toast.classList.add('is-visible');
    }, 10);

    window.setTimeout(function () {
      toast.classList.remove('is-visible');
      window.setTimeout(function () {
        toast.remove();
      }, 300);
    }, 4200);
  }

  function initShell() {
    var btn = document.querySelector('[data-xp-menu-toggle]');
    var drawer = document.querySelector('[data-xp-menu-drawer]');
    if (!btn || !drawer) return;

    btn.addEventListener('click', function () {
      var open = drawer.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    drawer.addEventListener('click', function (event) {
      if (event.target === drawer) {
        drawer.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
      }
    });
  }

  function initReveal() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      document.querySelectorAll('[data-xp-reveal]').forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var items = document.querySelectorAll('[data-xp-reveal]');
    if (!items.length || !('IntersectionObserver' in window)) {
      items.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );

    items.forEach(function (el) {
      observer.observe(el);
    });
  }

  function initDemoGuard() {
    if (!document.body.classList.contains('tsl-experience-mode')) return;

    var checkoutMessage =
      'Demo Experience: puedes probar el carrito lateral, pero no se procesan pagos.';

    document.addEventListener(
      'click',
      function (event) {
        var target = event.target.closest(
          'a[href*="/checkout"], button[name="checkout"], #checkout, .cart__checkout-button, shopify-accelerated-checkout, .shopify-payment-button'
        );

        if (!target) return;

        event.preventDefault();
        event.stopPropagation();
        showDemoToast(checkoutMessage);
      },
      true
    );

    document.addEventListener(
      'submit',
      function (event) {
        var form = event.target;
        if (!(form instanceof HTMLFormElement)) return;
        if (!form.action || form.action.indexOf('/checkout') === -1) return;
        event.preventDefault();
        showDemoToast(checkoutMessage);
      },
      true
    );
  }

  function initCartOpen() {
    var btn = document.querySelector('[data-xp-cart-open]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initShell();
    initReveal();
    initDemoGuard();
    initCartOpen();
  });
})();
